export default __webpack_public_path__ + "static/media/spotify.cd66b8f6.png";